export default __webpack_public_path__ + "static/bicak-izi-cizim-df92dfcb344d5555a3eb2298dabb839d.png";